import { render, staticRenderFns } from "./IconPhoneOutline.vue?vue&type=template&id=4be3e671"
import script from "./IconPhoneOutline.vue?vue&type=script&lang=js"
export * from "./IconPhoneOutline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports